"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styles_1 = require("@material-ui/core/styles");
const core_1 = require("@material-ui/core");
const FavoriteContentButton_1 = __importDefault(require("../shared/FavoriteContentButton"));
const components_1 = require("@alcumus/components");
const useStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    root: {
        width: theme.spacing(28),
        height: theme.spacing(20),
    },
    content: {
        padding: 0,
    },
    media: {
        height: 90,
    },
    titleContainer: {
        padding: '8px 16px 0 16px',
    },
    customNavlink: {
        color: components_1.StyleVariables.colors.text.default,
        textDecoration: 'underline',
        '&:hover': {
            color: components_1.StyleVariables.colors.action.primary.default,
        },
    },
    container: {
        padding: '0 16px',
        color: components_1.StyleVariables.colors.grey4,
    },
    tileDetail: {
        fontSize: '0.5rem',
    },
}));
const Tile = ({ data }) => {
    const classes = useStyles();
    const getViewCount = () => {
        return data.views && react_1.default.createElement("span", null,
            data.views,
            " Views,");
    };
    const getFavoriteCount = () => {
        return data.favourites !== 0 && react_1.default.createElement("span", null,
            data.favourites,
            " Favorites,");
    };
    const getCreatedBy = () => {
        return react_1.default.createElement("span", null,
            "Created By ",
            data.createdBy);
    };
    return (react_1.default.createElement(core_1.Card, { className: classes.root, variant: "outlined", "data-testid": "reportTile" },
        react_1.default.createElement(react_router_dom_1.NavLink, { to: data.basePath, className: classes.customNavlink },
            react_1.default.createElement(core_1.CardActionArea, null,
                react_1.default.createElement(core_1.CardMedia, { className: classes.media, image: "/images/report_placeholder.png", title: "thumbnail" }),
                react_1.default.createElement(core_1.CardContent, { className: classes.titleContainer },
                    react_1.default.createElement(components_1.Text, { as: "span", noWrap: true }, data.name)))),
        react_1.default.createElement(core_1.Grid, { container: true, wrap: "nowrap", direction: "row", className: classes.container },
            react_1.default.createElement(core_1.Grid, { item: true, xs: true, zeroMinWidth: true },
                react_1.default.createElement(core_1.CardContent, { className: classes.content },
                    react_1.default.createElement(components_1.Text, { as: "small", noWrap: true, className: classes.tileDetail },
                        getViewCount(),
                        " ",
                        getFavoriteCount(),
                        " ",
                        getCreatedBy()))),
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(FavoriteContentButton_1.default, { elementType: data.elementType, liked: data.liked, contentMetadataId: data.contentMetadataId, contentFavoriteId: data.contentFavoriteId, handleOnDeleteFavorite: () => null })))));
};
exports.default = Tile;
